interface CeloIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const CeloIcon: React.FC<CeloIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1399 1408"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1398.6 0H0V1407.7H1398.7V916.3H1166.6C1086.6 1095.6 906.5 1220.4 700.4 1220.4C416.3 1220.4 186.2 986.8 186.2 702.9C186.2 418.9 416.3 187.3 700.4 187.3C910.5 187.3 1090.6 316.2 1170.6 499.4H1398.7V0H1398.6Z"
        fill={colored ? '#35D07F' : 'currentColor'}
      />
    </svg>
  )
}
